import React from "react";
import LineIndicator from "../../../components/dashboard/Crypto/LineIndicator";
import { getColorByScale } from "./colorUtils";

const CurrentStatusMiddle = React.memo(({ statusBreakup, loading }) => {
  let total = 0;
  statusBreakup.map(st => total += st.jobs.length);
  return (
    <>
      {/*<div className="gx-site-dash gx-align-content-center gx-vertical-align-middle" style={{justifyContent: 'center', verticalAlign: 'center'}}>*/}
      {/*<h4 className="gx-mb-3">Current Status Distribution</h4>*/}
      <div className="gx-text-center">
        <div className="gx-py-3">
          <h4 className="gx-mb-3 dash-card-title">Current Status Distribution</h4>
          {/*<ResponsiveContainer width="100%" height={150}>*/}
          {
            statusBreakup && statusBreakup.length > 0 ?
              <ul className="gx-line-indicator gx-fs-sm gx-pb-1 gx-pb-sm-0">
                {
                  statusBreakup.map((status, index) => {
                    if (status.jobs && status.jobs.length > 0 && total > 0) {
                      const count = status.jobs && status.jobs.length || 0;
                      let scale = Math.ceil((count / total) * 100);
                      const { className: color } = getColorByScale(scale);
                      return <li key={index}>
                        <LineIndicator width={`${scale}`} title={status._id || ''} title2={`${scale}%`} color={color}
                          value={`${count}`} />
                      </li>
                    }
                  }
                  )
                }
              </ul> : null
          }
        </div>
        {/*<p className="gx-text-primary gx-pointer gx-d-block gx-d-sm-none gx-mb-0 gx-mt-3">*/}
        {/*<i className="icon icon-add-circle gx-fs-lg gx-d-inline-flex gx-vertical-align-middle"/> Add New Wallet*/}
        {/*</p>*/}
      </div>

    </>);
});

export default CurrentStatusMiddle;
